import React from "react";

/**
 * Wraps a missed-cut pick row: dims the existing card (parchment, type, avatar)
 * via opacity + desaturation; the CUT stamp sits in that same layer (not above it).
 */
export function MissedCutPickCardShell({ children, className = "" }) {
    return (
        <div className={`relative rounded-lg ${className}`.trim()}>
            <div className="relative rounded-lg opacity-[0.58] saturate-[0.72]">
                {children}
                <span
                    className="pointer-events-none absolute left-1/2 top-[52%] origin-left -translate-y-1/2 -rotate-[11deg] select-none whitespace-nowrap rounded-sm border-[0.2em] border-red-900/55 px-2 py-1 font-black uppercase leading-none tracking-[0.14em] text-red-900/80 shadow-sm sm:tracking-[0.2em]"
                    style={{
                        fontSize: "clamp(0.98rem, 4.2vw, 1.23rem)",
                        textShadow: "0.05em 0.05em 0 rgb(0 0 0 / 0.12)",
                    }}
                    aria-hidden
                >
                    CUT
                </span>
            </div>
        </div>
    );
}
